// components/ToDoStatusChip.js
import React from 'react'
import { Chip } from '../../../../components/common/Chip'
import { useTrans } from '../../../../services/i18n'

// normalize various incoming values to a stable key
const normalize = (v = '') => {
  const s = String(v).trim().toLowerCase()
  if (s === 'completed' || s === 'complete' || s === 'done') return 'completed'
  if (s === 'in progress' || s === 'in_progress' || s === 'progress') return 'in_progress'
  return 'not_started'
}

// pick your brand colors
const colorMap = {
  not_started: '#F32445',  // red-ish
  in_progress: '#FFAC00',  // amber
  completed:   '#17B471',  // green
}

const labelMap = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  completed:   'Completed',
}

const StatusChip = React.memo(({ status }) => {
  const { trans } = useTrans()
  const key = normalize(status)
  return (
    <Chip
      label={trans(labelMap[key] || key)}
      color="secondary"
      style={{ backgroundColor: colorMap[key] || '#999' }}
    />
  )
})

export default StatusChip
